var _style, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.bst0{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\r\n\t.bst1{fill:currentColor;stroke:#000000;stroke-width:5.4609;stroke-miterlimit:10;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.43,
    y: -0.82,
    className: "bst0",
    width: 360,
    height: 360
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bst1",
    d: "M252.82,205.75c-10.18-1.59-20.35-3.23-30.53-4.74c-3.11-0.46-6.27-0.67-9.41-0.83 c-7-0.37-12.12,2.71-16.65,8.04c-28.25,33.2-56.7,66.24-85.11,99.3c-1.77,2.06-3.74,3.96-5.67,5.89 c-14.83,14.83-32.97,17.79-51.88,8.5c-21.62-10.62-32.32-36.23-24.5-58.48c2.97-8.45,8.75-14.64,15.46-20.23 c30.3-25.25,60.55-50.55,90.82-75.84c4.4-3.68,8.77-7.4,13.19-11.05c4.21-3.46,6.21-7.86,5.51-13.27 c-1.15-8.95-2.64-17.85-3.69-26.81c-3.84-33.02,8.87-58.79,35.08-78.26c14.09-10.47,30.03-16.6,47.67-17.81 c3.13-0.21,6.31-0.05,9.43,0.3c2.67,0.3,5.89-0.55,7.37,3.05c1.84,4.47,3.67,8.99,0.53,13.47c-2.04,2.92-4.5,5.58-7.02,8.1 c-10.75,10.75-21.54,21.47-32.44,32.06c-2.43,2.36-3.26,4.55-2.11,7.9c4.62,13.4,9.08,26.85,13.44,40.33 c1.16,3.59,3.24,5.78,6.84,6.95c13.75,4.46,27.47,9.03,41.17,13.67c2.82,0.95,4.74,0.29,6.79-1.84 c10.26-10.63,20.67-21.11,31.02-31.65c3.93-4,7.94-7.68,13.61-9.38c6.74-2.02,13.66,3.24,13.49,9.77 c-0.17,6.54,0.03,13.36-1.71,19.56c-7.26,25.97-21.18,47.52-44.33,62.25C278.2,201.7,266.08,205.33,252.82,205.75z M74.87,303.09 c12.67-0.06,22.9-10.66,22.86-23.69c-0.04-12.66-11.22-23.49-24.3-23.54c-12.66-0.05-23.17,11.02-23.21,24.46 C50.18,293.06,61.11,303.16,74.87,303.09z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.cca5994f9a976c2fa8162f92665bb63a.svg";
export { ForwardRef as ReactComponent };